import { Component, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSystemService } from '../../services/file-system.service';

@Component({
  selector: 'app-imageviewer',
  templateUrl: './imageviewer.component.html',
  styleUrls: ['./imageviewer.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class ImageviewerComponent{
  imageUrl: string | null = null;

  constructor(private fileSystemService: FileSystemService) {
    effect(() => {
      const node = this.fileSystemService.visibleNode();
      node.getBlob().then((blob) => {
        if (blob) {
          this.imageUrl = URL.createObjectURL(blob);
        } else {
          this.imageUrl = null;
        }
      });
      // if (node.content) {
      //   this.imageUrl = node.content;
      // } else {
      //   this.imageUrl = null;
      // }
    });
  }

}
